module.exports = __webpack_public_path__ + "img/F122.aba87c0f.jpg";